
import get from 'lodash/get';

export default function getPromiseCallback(resolve, reject, options={}) {
    return (err, response) => {
        if (err) {
            reject(err);
        } else {
            if (options && options.responseSelector) {
                response = get(response, options.responseSelector);
            }
            resolve(response);
        }
    }
}
